import { render, staticRenderFns } from "./ReviewPlatforms.vue?vue&type=template&id=647cd01a"
import script from "./ReviewPlatforms.vue?vue&type=script&lang=js"
export * from "./ReviewPlatforms.vue?vue&type=script&lang=js"
import style0 from "./ReviewPlatforms.vue?vue&type=style&index=0&id=647cd01a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports